import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './style.css';

function ConfirmDialog(props) {
  const { show, title, body, handleClose, onConfirm } = props;

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton className="confirm-dialog-header">
          <Modal.Title className="confirm-dialog-modal-title">
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="confirm-dialog-modal-body">{body}</Modal.Body>
        <Modal.Footer>
          <span
            className="confirm-dialog-btn-cancel"
            onClick={handleClose}
            role="button"
            tabIndex={0}
          >
            cancelar
          </span>
          <Button variant="primary" onClick={onConfirm}>
            confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ConfirmDialog;
